import React from 'react';
import useAppName from '../../hooks/useAppName';
import {
  HONDA_SITE_NAME,
  ACURA_SITE_NAME,
  MC_SITE_NAME,
  PE_SITE_NAME,
  ENGINE_SITE_NAME,
  ATVSXS_SITE_NAME,
} from '../../utils/constants';
import { variant0, variant1, variant2, variant3, variant4, variant5, variant6 } from '../../utils/variantConfig';
import VINSearchAndResults from '../VINSearchAndResults';
import { VariantContextProvider } from '../../contexts/VariantContext';

const VINSearchApp = () => {
  const appName = useAppName();

  let variant;

  switch (appName) {
    case HONDA_SITE_NAME:
      variant = variant1;
      break;
    case ACURA_SITE_NAME:
      variant = variant2;
      break;
    case MC_SITE_NAME:
      variant = variant3;
      break;
    case PE_SITE_NAME:
      variant = variant4;
      break;
    case ENGINE_SITE_NAME:
      variant = variant5;
      break;
    case ATVSXS_SITE_NAME:
      variant = variant6;
      break;
    default:
      variant = variant0;
      break;
  }
  return (
    <VariantContextProvider variant={variant}>
      <VINSearchAndResults />
    </VariantContextProvider>
  );
};

export default VINSearchApp;
